export default __webpack_public_path__ + "static/media/news51.6609684c.jpg";